import AppRoutes from './routes/index.jsx';

export default function App() {
  return <AppRoutes />;
}
